import StickyBanner from './StickyBanner';

export default StickyBanner;
